import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Link from "components/link";
import IconButton from "components/icon-button";
import {FormattedMessage} from "react-intl";
import Icon from "components/icon";
import {ConnectedPaginatedTable, TableIconCell, CustomTableRow} from "components/table";
import PropTypes from "prop-types";
import {HeaderCell} from "components/table";
import query from "./query";

const Header = () => (
    <TableRow>
        <HeaderCell>
            <FormattedMessage id="common.name"/>
        </HeaderCell>
        <TableIconCell/>
    </TableRow>
);

const RowComponent = ({item}) => {
    const detailsUrl = `/contract/details/${item.id}`;
    return (
        <CustomTableRow key={item.id} href={detailsUrl}>
            <TableCell>{item.name}</TableCell>
            <TableIconCell>
                <Link href={detailsUrl} target="_blank" rel="noopener">
                    <IconButton>
                        <Icon name="launch"/>
                    </IconButton>
                </Link>
            </TableIconCell>
        </CustomTableRow>
    );
};

RowComponent.propTypes = {
    /**
     ** Elemento a representar en la fila de la tabla
     **/
    item: PropTypes.object,
};

const ContractPaginatedTable = ({variables, debounce}) => (
    <ConnectedPaginatedTable
        variables={variables}
        gqlQuery={query}
        headerComponent={Header}
        rowComponent={RowComponent}
        debounce={debounce}
        paginatedElementsHandler={data => data.customerContracts}
    />
);

ContractPaginatedTable.propTypes = {
    /**
     ** Objeto que contiene los filtrados de la búsqueda
     **/
    variables: PropTypes.object,
    /**
     * Debouncea o no la recarga de la query de la tabla
     **/
    debounce: PropTypes.bool,
};

export default ContractPaginatedTable;
